module["exports"] = [
  "stadt",
  "dorf",
  "land",
  "scheid",
  "burg"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de/address/city_suffix.js
 ** module id = 319
 ** module chunks = 0
 **/